import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage15.module.css"
import Common_html from './Common_html'
import BlockData from "../../../layman-explanation-json/hermes.json";

export default function LaymanPage15() {
  return (
    <>
  <Common_html BlockData={BlockData} />
    </>
  )
}
